import $ from 'jquery';

class PopUp {

    constructor() {
        $(document).ready(() => {
            this.$popup = $('.js-popup');
            this.$canvas = $('.js-popup__canvas');
            this.openButton = $('.js-open-popup');
            this.closeButton = $('.js-close-popup');
            this.$getReg = $('.js-getReg');
            this.tabSwitchers = $('.js-switch-tabs');
            this.choosePlanBtns = $('.js-choose-plan');
            this.header = $('.js-header');
            this.layout = $('.js-o-layout');
            this.registerTab = $('.js-register-tab');
            this.mainHeading = this.$popup.find('.js-main-heading');
            this.mainDesc = this.$popup.find('.js-main-description');
            this.popupPreset = $('[data-popup]').data('popup');
            this.goBackOnClose = false;

            if (this.$popup.length && this.openButton.length) {
                this.registerListeners();

                if (this.popupPreset) {
                    this.applyPreset()
                }

                if (this.$getReg.length) {
                    this.openPopUp();
                }

            }
        });
    }

    registerListeners() {
        this.openButton.click(e => {
            e.preventDefault();
            this.openPopUp();
        });

        this.closeButton.click(e => {
            e.preventDefault();
            this.closePopUp();
        });

        $(document).on('popup.open', (data) => {
            this.openPopUp(data);
        });
        $(document).on('popup.close', () => {
            this.openPopUp();
        });
        // this.$popup.click(event => {
        //     if (event.currentTarget === event.target) {
        //         this.closePopUp();
        //     }
        // });

        this.tabSwitchers.click(e => {
            let currentTab = $('.c-popup__tab-container--active');
            let selector = $(e.currentTarget).data('target');
            let targetTab = $(selector);

            //check if the target exists
            if (targetTab.length === 1) {
                this.tabSwitchers.removeClass('c-popup__tab-btn--active');
                $(e.currentTarget).addClass('c-popup__tab-btn--active');
                currentTab.removeClass('c-popup__tab-container--active');
                targetTab.addClass('c-popup__tab-container--active');
            }
        });

        this.choosePlanBtns.click(e => {
            let id = $(e.currentTarget).data('id');
            let planId = '#plan-' + id;
            let variotanId = '#plan-variations-' + id;
            $('.c-popup__subs-plans-container').removeClass('c-popup__subs-plans-container--active');
            $('.c-popup__plan-container').removeClass('c-popup__plan-container--active');
            $(planId).addClass('c-popup__plan-container--active');
            $(variotanId).addClass('c-popup__subs-plans-container--active');
            this.tabSwitchers.removeClass('c-popup__tab-btn--active');
            this.registerTab.addClass('c-popup__tab-btn--active');
            $('#plan-prod-id').val(id);
        });
    }

    openPopUp(data) {
        if (data) {
            //TODO: hide unwanted plans depending on the data
            console.log('Plan hide data', data);
        }
        this.header.addClass('c-header--pop-up-active');
        this.layout.addClass('o-layout--pop-up-active');
        $('body').addClass('pop-up-active');
        this.$popup.fadeIn();
    }

    closePopUp() {
        this.header.removeClass('c-header--pop-up-active');
        this.layout.removeClass('o-layout--pop-up-active');
        $('body').removeClass('pop-up-active');
        if(this.goBackOnClose){
            window.history.back();
        }else{
            this.$popup.fadeOut();
        }
    }

    applyPreset() {
        if (this.popupPreset.heading) {
            this.mainHeading.text(this.popupPreset.heading)
        }
        if (this.popupPreset.description) {
            this.mainDesc.html(this.popupPreset.description)
        }
        if (this.popupPreset['close_btn_override'] && this.popupPreset['close_btn_override'] === 'back-btn') {
            this.goBackOnClose = true;
        }
        if (this.popupPreset.show) {
            this.closeButton.html('Go back');
            this.openPopUp();
        }
    }

}

export default PopUp;
